import { PatientPreview } from "~/providers/components/patientPreview";

export const OngoingPatientPreview = () => <PatientPreview />;
